import React from 'react'
import {
  columnCover,
  columnInfo,
  columnName,
  columnPreview,
  columnState,
} from 'components/template-data-table-column'
import { openOnlinesByPainter } from 'commons/worksLinks'
import DisplayUpdateTime from 'ui/DisplayUpdateTime'
import { DataTableRowActions } from './data-table-row-action'

const columnPublisher = {
  header: 'Publisher',
  accessorKey: 'publisher',
  cell: ({ row, table }) => {
    const publisherId = row.original.painter
    const name = row.original.publisher
    const onPublisherClick = table.options.meta?.onPublisherClick

    if (onPublisherClick && publisherId) {
      return (
        <button
          type="button"
          className="font-medium underline underline-offset-4"
          onClick={() => onPublisherClick(publisherId)}
          title={publisherId}
        >
          {name || publisherId}
        </button>
      )
    }

    return <span>{name || '-'}</span>
  },
}

const columnPainter = {
  header: 'Painter',
  accessorKey: 'painter',
  cell: ({ row }) => {
    const painterId = row.original.author
    const name = row.original.onlinePublisher

    if (!painterId) {
      return <span>{name || '-'}</span>
    }

    return (
      <button
        type="button"
        className="font-medium underline underline-offset-4"
        title={painterId}
        onClick={() => openOnlinesByPainter(painterId)}
      >
        {name || painterId}
      </button>
    )
  },
}

export const columns = [
  {
    header: '#',
    cell: ({ row }) => row.index + 1,
  },
  columnCover,
  columnPreview,
  columnName,
  columnInfo,
  columnState,
  columnPublisher,
  columnPainter,
  {
    header: 'DLC',
    accessorKey: 'dlcCount',
    cell: ({ row }) => {
      const n = row.original.dlcCount
      if (n == null || n === 0) return '—'
      return n
    },
  },
  {
    header: 'Publish Time',
    accessorKey: 'publishTime',
    cell: ({ row }) => (
      <DisplayUpdateTime updateTime={row.original.publishTime} />
    ),
  },
  {
    header: 'Actions',
    cell: ({ row }) => <DataTableRowActions row={row} />,
  },
]
